import React from 'react';
// @ts-ignore
import styles from './WorkplaceOrWorkplaceMemberSelectItem.module.scss';
import Text from '../../../../Components/Base/Text/Text';

type Workplace = {
	id: string;
	doctorDisplayName: string;
	rootWorkplace?: {
		id: string;
		doctorDisplayName: string;
	};
};

interface Props {
	onSelect: (id: string, label: string, item: Workplace) => void;
	item: Workplace;
}

const WorkplaceOrWorkplaceMemberSelectWorkplaceItem: React.FC<Props> = ({
	item,
	onSelect,
}) => {
	const handleSelect = () => {
		onSelect(item.id, item.doctorDisplayName, item);
	};

	return (
		<div className={styles.wrapper} onClick={handleSelect}>
			<div className={styles.header}>
				<div className={styles.title}>{item.doctorDisplayName}</div>
			</div>
			{item.rootWorkplace && (
				<div className={styles.content}>
					<Text tx='base.shared.workplace' firstUpper inline />:{' '}
					{item.rootWorkplace.doctorDisplayName}
				</div>
			)}
		</div>
	);
};

export default WorkplaceOrWorkplaceMemberSelectWorkplaceItem;
